import React from "react";
import ScrollToTop from "react-scroll-to-top";
import Layout from "../../components/user/Layout";
import ProductDetails from "../../components/user/ProductDetails";
import { useParams } from "react-router-dom"


const ProductDetailsPage = () => {

    const { productID } = useParams()

  return (
    <>
      <Layout>

        {/* ProductDetailsTwo */}
        <ProductDetails productID = {productID}/>
      </Layout>

    </>
  );
};

export default ProductDetailsPage;
